/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-external {
  display: none;
  height: 1.25em;
  margin-inline-start: var(--qds-text-icon-gap);
  vertical-align: text-top;
  width: 1.25em;
}

.qds-inline-link {
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;

  &[rel~='external'] > .qds-external {
    display: inline-block;
  }

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }
}

[aria-disabled='true'] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-importance='subdued'] {
  &.qds-inline-link {
    color: var(--qds-theme-link-subdued-default);

    &:visited {
      color: var(--qds-theme-link-subdued-visited);
    }

    &:hover {
      color: var(--qds-theme-link-subdued-hover);
    }

    &:active {
      color: var(--qds-theme-link-subdued-pressed);
    }

    &:visited:hover {
      color: var(--qds-theme-link-subdued-visited-hover);
    }

    &:visited:active {
      color: var(--qds-theme-link-subdued-visited-pressed);
    }
  }
}

[data-importance='standard'] {
  &.qds-inline-link {
    color: var(--qds-theme-link-standard-default);

    &:visited {
      color: var(--qds-theme-link-standard-visited);
    }

    &:hover {
      color: var(--qds-theme-link-standard-hover);
    }

    &:active {
      color: var(--qds-theme-link-standard-pressed);
    }

    &:visited:hover {
      color: var(--qds-theme-link-standard-visited-hover);
    }

    &:visited:active {
      color: var(--qds-theme-link-standard-visited-pressed);
    }
  }
}

[data-importance='emphasized'] {
  color: var(--qds-theme-link-emphasized-default);

  &:visited {
    color: var(--qds-theme-link-emphasized-visited);
  }

  &:hover {
    color: var(--qds-theme-link-emphasized-hover);
  }

  &:active {
    color: var(--qds-theme-link-emphasized-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-emphasized-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-emphasized-visited-pressed);
  }
}
